import {AxiosResponse} from 'axios';
import {axiosInstance} from '../..';

export function getScaleBrand(): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`ScaleBrand`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function getScaleBrandId(id: string): Promise<AxiosResponse<any, any>> {
    return axiosInstance.get(`ScaleBrand/${id}`, {
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    });
}

export function createScaleBrand(data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.post('ScaleBrand', data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

export function updateScaleBrandId(id: string, data: any): Promise<AxiosResponse<any, any>> {
  return axiosInstance.put(`ScaleBrand/${id}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}
export function deleteScaleBrandId(id: string): Promise<AxiosResponse<any, any>> {
  return axiosInstance.delete(`ScaleBrand/${id}`, {
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  });
}

